import React, { useEffect, useState } from 'react';
import { getVillages } from '../services/authService';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedVillageId } from '../slices/villageSlice';

const VillageSelector = () => {
  const [villages, setVillages] = useState([]);
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  const selectedVillageId = useSelector((state) => state.village.selectedVillageId);

  useEffect(() => {
    const fetchVillages = async () => {
      try {
        const asha_id = localStorage.getItem('asha_id');
        const response = await getVillages(asha_id);
        const villageList = response.data || [];
        const VillageId = localStorage.getItem('VillageId');
        if(!VillageId){
        dispatch(setSelectedVillageId(villageList[0].village_id))
        } 
        setVillages(villageList);
        
      } catch (error) {
        console.error('Error fetching villages:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchVillages();
  }, []);

  const handleChange = (e) => {
    const id = e.target.value;
    dispatch(setSelectedVillageId(id));
  };

  return (
    <div className="village-selector">
      <i className="fas fa-map-marker-alt village-icon"></i>
      <select
        className="village-select"
        value={selectedVillageId}
        onChange={handleChange}
        disabled={loading}
      >
        {loading ? (
          <option>Loading villages...</option>
        ) : villages.length > 0 ? (
          <>
            <option value="">Select Village</option>
            {villages.map((village) => (
              <option key={village.village_id} value={village.village_id}>
                {village.village_name}
              </option>
            ))}
          </>
        ) : (
          <option>No villages available</option>
        )}
      </select>
    </div>
  );
};

export default VillageSelector;
  